import * as a11y from '../vendor/theme-scripts/theme-a11y';

const selectors = {
  details: 'details',
  input: 'input:not([type="hidden"])',
  popdown: '[data-popdown]',
  popdownClose: '[data-popdown-close]',
  popdownToggle: '[data-popdown-toggle]',
  predictiveSearch: 'predictive-search',
};

const attributes = {
  popdownUnderlay: 'data-popdown-underlay',
};

const classes = {
  searchPopdownVisible: 'has-search-popdown-visible',
};

class SearchPopdown extends HTMLElement {
  constructor() {
    super();
    this.popdown = this.querySelector(selectors.popdown);
    this.popdownContainer = this.querySelector(selectors.details);
    this.popdownToggle = this.querySelector(selectors.popdownToggle);
    this.popdownClose = this.querySelector(selectors.popdownClose);
    this.a11y = a11y;
  }

  connectedCallback() {
    this.popdownContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.popdownClose.addEventListener('click', this.close.bind(this));
    this.popdownToggle.addEventListener('click', this.onPopdownToggleClick.bind(this));
    this.popdownToggle.setAttribute('role', 'button');
    this.popdown.addEventListener('transitionend', (event) => {
      if (event.propertyName == 'visibility' && this.popdownContainer.hasAttribute('open') && this.popdownContainer.getAttribute('open') == 'false') {
        this.closeCallback();
      }
    });
  }

  onPopdownToggleClick(event) {
    event.preventDefault();
    event.target.closest(selectors.details).hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.hasAttribute(attributes.popdownUnderlay)) this.close();
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest(selectors.details).setAttribute('open', '');

    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add(classes.searchPopdownVisible);
    document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: this.popdown}));

    // Safari opening transition fix
    requestAnimationFrame(() => {
      event.target.closest(selectors.details).setAttribute('open', 'true');

      // Trap focus after opening transition ends
      this.popdown.addEventListener(
        'transitionend',
        (e) => {
          if (e.target == this.popdown) {
            this.a11y.trapFocus(this.popdown, {
              elementToFocus: this.popdown.querySelector(selectors.input),
            });
            theme.a11yTrigger = event.target;
          }
        },
        {once: true}
      );
    });
  }

  close() {
    this.popdownContainer.setAttribute('open', 'false');

    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
  }

  closeCallback() {
    this.popdownContainer.removeAttribute('open');
    this.a11y.removeTrapFocus();
    if (theme.a11yTrigger !== null) {
      theme.a11yTrigger.focus();
    }

    document.body.classList.remove(classes.searchPopdownVisible);
  }
}

customElements.define('header-search-popdown', SearchPopdown);
